var React = require('react');

function ChevronUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7.53999 5.29036C7.79383 5.03652 8.20539 5.03652 8.45923 5.29036L11.9592 8.79036C12.2131 9.0442 12.2131 9.45575 11.9592 9.70959C11.7054 9.96344 11.2938 9.96344 11.04 9.70959L7.99961 6.66921L4.95923 9.70959C4.70539 9.96344 4.29383 9.96344 4.03999 9.70959C3.78615 9.45575 3.78615 9.0442 4.03999 8.79036L7.53999 5.29036Z","fill":"currentColor"}));
}

ChevronUp.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ChevronUp;

ChevronUp.default = ChevronUp;
